import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=42fd8907&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=ts"
export * from "./ContactInfo.vue?vue&type=script&lang=ts"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=42fd8907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd8907",
  null
  
)

export default component.exports